import React from 'react';
import ReportContextProvider from 'contexts/report/ReportContext';
import { AccountType } from 'globals/types';
import ReportMainTabsSection from './ReportMainTabsSection';
import ReportBasicInfoSection from './ReportBasicInfoSection';
import ReportCashflowSummarySection from './ReportCashflowSummarySection/ReportCashflowSummarySection';
import ReportCashflowChartsSection from './ReportCashflowChartsSection';
import ReportTopRecurringTransactions from './ReportTopRecurringTransactions';
import ReportBoxes from './ReportBoxes';
import ReportAccount from './ReportAccount';
import ReportModals from './ReportModals/ReportModals';
import ReportPersonalAndBusinessData from './ReportPersonalAndBusinessData';

const Report: React.FC = () => {
  return (
    <ReportContextProvider
      userId="129"
      accountTypes={[AccountType.PERSONAL, AccountType.BUSINESS]}
    >
      <ReportModals />
      <ReportMainTabsSection />
      <ReportBasicInfoSection />
      <ReportPersonalAndBusinessData />
      <ReportCashflowChartsSection />
      <ReportCashflowSummarySection />
      <ReportTopRecurringTransactions />
      <ReportBoxes />
      <ReportAccount />
    </ReportContextProvider>
  );
};

export default Report;
